if (!customElements.get('video-popup')) { 
    class VideoPopup extends HTMLElement {

        constructor() {

            super();

            this.querySelector('[data-js-video-popup-link]').addEventListener('click', e => {

                e.preventDefault();

                const blackout = document.createElement('div');
                blackout.classList.add('video-popup__blackout');
                this.append(blackout);
                setTimeout(() => {
                    blackout.style.opacity = '1';
                }, 10)

                this.classList.add('video-opened');

                const overlay = this.querySelector('.video-popup__overlay-content');
                if (overlay) overlay.style.display = 'none';

                if (this.querySelector('[data-js-video-popup-close]')) {
                    this.querySelector('[data-js-video-popup-close]').addEventListener('click', e => {
                        this.querySelectorAll('iframe, video').forEach(elm => {
                            elm.remove()
                        });
                        blackout.remove();
                        this.classList.remove('video-opened');

                        if (overlay) overlay.style.display = '';
                    });
                }

                setTimeout(() => {
                    this.querySelector('[data-js-video-popup-container]').appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
                    setTimeout(() => {
                        this._playMedia(this.closest('[data-video]'));
                    }, 500);
                }, 50);

            });

        }

        _playMedia(media) {
            switch (media.dataset.productMediaType) {
                case 'video':
                    if (media.querySelector('video')) {
                        media.querySelector('video').play();
                    }
                    break;
                case 'external_video-youtube':
                    if (media.querySelector('.js-youtube')) {
                        media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                    }
                    break;
                case 'external_video-vimeo':
                    if (media.querySelector('.js-vimeo')) {
                        media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
                    }
                    break;
            }
        }

    }
    customElements.define('video-popup', VideoPopup);
}

if (!customElements.get('consent-video')) {
    class ConsentVideo extends HTMLElement {
        constructor() { super(); }


        connectedCallback() {   
            document.addEventListener("DOMContentLoaded", () => {
                setTimeout(() => {
                    this.checkConsent(window.Shopify.trackingConsent.preferencesProcessingAllowed());
                }, 8000);
            });
            this.subscriber = subscribe(PUB_SUB_EVENTS.onCookieChange, (event) => {
                this.checkConsent(event)
            });
        }

        checkConsent(consent) {
            const video = this.querySelector('video');
            if (video) {
            video.currentTime = 0;
            video.play();
            }

            const youtube = this.querySelector('.js-youtube');
            if (youtube) {
                youtube.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0, true]}', '*');
                youtube.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }

            // Restart Vimeo iframe
            const vimeo = this.querySelector('.js-vimeo');
            if (vimeo) {
                vimeo.contentWindow.postMessage('{"method":"setCurrentTime","value":0}', '*');
                vimeo.contentWindow.postMessage('{"method":"play"}', '*');
            }
            this.querySelector('[data-image]')?.toggleAttribute('hidden', consent);
        }


    }
    customElements.define('consent-video', ConsentVideo);
}